export type CollaboratorTypeWithoutOwner = 'editor' | 'viewer';
export type CollaboratorType = CollaboratorTypeWithoutOwner | 'owner';

export function isCollaboratorType(collaborator_type: any): collaborator_type is CollaboratorType {
    return collaborator_type === 'editor' || collaborator_type === 'viewer' || collaborator_type === 'owner';
}

export class Collaborator {
    private readonly user: string;
    private readonly email: string;
    private readonly type: CollaboratorType;

    constructor(user: string, email: string, type: CollaboratorType) {
        this.user = user;
        this.email = email;
        this.type = type;
    }

    get User() {
        return this.user;
    }

    get Email() {
        return this.email;
    }

    get Type() {
        return this.type;
    }

    get isOwner() {
        return this.type === 'owner';
    }

    get TypeLabel(): 'オーナー' | '編集者' | '閲覧者' {
        const label_map = {
            'owner': 'オーナー',
            'editor': '編集者',
            'viewer': '閲覧者',
        } as const;
        return label_map[this.type];
    }

    changeType(type: CollaboratorTypeWithoutOwner): Collaborator {
        if (this.Type === 'owner') {
            throw new Error("cannot change owner");
        }

        return new Collaborator(this.user, this.email, type);
    }
}
